module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10238.3a23892e.jpg";